import * as React from "react"
import Svg, { Path } from "react-native-svg"

const LikeIcon = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M19.2 11.136c0-1.008-.816-1.536-1.92-1.536h-3.216c.24-.864.336-1.68.336-2.4 0-2.784-.768-3.36-1.44-3.36-.432 0-.768.048-1.2.288-.144.096-.192.192-.24.336l-.48 2.592C10.512 8.4 9.216 9.6 8.16 10.416v6.864c.384 0 .768.192 1.248.432.528.24 1.056.528 1.632.528h4.56c.96 0 1.68-.768 1.68-1.44 0-.144 0-.24-.048-.336.576-.24 1.008-.72 1.008-1.344a1.99 1.99 0 0 0-.144-.768c.384-.24.72-.672.72-1.152 0-.288-.144-.576-.288-.816.384-.288.672-.768.672-1.248Zm-1.008 0c0 .624-.624.672-.72.96-.096.336.384.432.384 1.008 0 .576-.72.576-.816.912-.096.384.24.48.24 1.056v.096c-.096.48-.816.528-.96.72-.144.24 0 .336 0 .864 0 .288-.336.48-.72.48h-4.56c-.384 0-.768-.192-1.248-.432-.384-.192-.768-.384-1.152-.48v-5.04c1.2-.912 2.736-2.256 3.312-3.936v-.096l.432-2.4c.192-.048.336-.048.576-.048.096 0 .48.576.48 2.4 0 .72-.144 1.488-.384 2.4h-.096c-.288 0-.48.192-.48.48s.192.48.48.48h4.32c.48 0 .912.24.912.576Z"
      fill="#716C6C"
    />
    <Path
      d="M7.68 18.24H4.8a.963.963 0 0 1-.96-.96v-6.72c0-.528.432-.96.96-.96h2.88c.528 0 .96.432.96.96v6.72c0 .528-.432.96-.96.96ZM4.8 10.56v6.72h2.88v-6.72H4.8Z"
      fill="#716C6C"
    />
  </Svg>
)


export default LikeIcon
